const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/; // eslint-disable-line

const validate = (values: any) => {
  const errors: any = {};
  
  if (!values.inn) {
    errors.inn = 'Обязательное поле';
  } else if (values.inn.length < 10 || values.inn.length > 12) {
    errors.inn = 'Длина ИНН должна быть от 10 до 12 символов';
  }
  
  if (!values.region) {
    errors.region = 'Обязательное поле';
  }
  
  if (!values.phoneNumber) {
    errors.phoneNumber = 'Обязательное поле';
  }

  if (!values.email) {
    errors.email = 'Обязательное поле';
  } else if (!emailPattern.test(values.email.toLowerCase())) {
    errors.email = 'Неверный формат электронной почты';
  }
  
  if (values.comment && values.comment.length > 255) {
    errors.comment = 'Максимальная длина 255 символов';
  }

  return errors;
};

export default validate;
